import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@app/_models';
import { AccountService, AlertService, AutomationService, ConnectionService } from '@app/_services';
import { environment } from '@environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-url-redirect-auth',
  templateUrl: './slack-url-redirect-auth.component.html',
  styleUrls: ['./slack-url-redirect-auth.component.less']
})
export class SlackUrlRedirectAuthComponent implements OnInit {

  urlFind = "";
  connector: any;
  openAuthenticationDetail: any;
  uid = "";
  auid = "";
  user: User;
  isProgress = true;
  status = true;
  errorMsg = '';

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private automationservice: AutomationService,
    private connectionservice: ConnectionService,
    private accountService: AccountService,
    private spinner: NgxSpinnerService,) {
    this.user = this.accountService.userValue;
  }

  ngOnInit() {
    // localStorage.setItem('EXPIRE_TIME_KEY', (Date.now() + 10).toString())
    // const expireTime = +localStorage.getItem('EXPIRE_TIME_KEY')
    // if (Date.now() > expireTime) {
    //   localStorage.removeItem('EXPIRE_TIME_KEY')
    // }

    this.uid = this.activatedRoute.snapshot.params['uid'];
    this.auid = this.activatedRoute.snapshot.params['auid'];
    this.activatedRoute.queryParams.subscribe(params => {
      const refreshToken = params['code'];
      const xrfTokenPrm = params['state'];
      const xrfToken=localStorage.getItem("stateKey");
      if(xrfToken!=null && xrfTokenPrm==xrfToken){
        localStorage.removeItem("stateKey");
        this.onReturnAuthenticate(refreshToken);
      }else{
        this.status=false;
        this.isProgress=false;
      }
    });
  }

  onReturnAuthenticate(refreshToken: string) {
    this.urlFind = this.router.url;
    if (this.urlFind.includes('action') && refreshToken) {
      this.spinner.show();
      
      this.connectionservice.getconnectoropenAuthentication(this.auid, 'A')
        .pipe(first())
        .subscribe(cId => {
          this.connector = cId;
          this.openAuthenticationAction(this.connector.cid, refreshToken);
        },
          error => {
            if (error == "Bad Request") {
              this.errorHandler("Connector Id Not Found");
            }
          }
        );
    } else {
      const link = "./connection/automation/" + this.user.uId;
      this.router.navigate([link]);
    }
  }

  openAuthenticationAction(cId, refreshToken: String) {
    const redirect_url = `${environment.slackPublishReturnURL}${this.uid}/action/${this.auid}`;
    this.connectionservice.getOpenAuthenticationConnectorDetail(cId)
      .pipe(first())
      .subscribe(data => {
        this.openAuthenticationDetail = data;
        this.connectionservice.postSlackOpenAuthentication(
          this.openAuthenticationDetail.clientid,
          this.openAuthenticationDetail.clientsecret,
          this.openAuthenticationDetail.accesstokenreq,
          refreshToken,
          redirect_url)
          .pipe(first())
          .subscribe(
            (data: any) => {
              if (data.ok) {
                this.connectionservice.PostRefereshTokenAction(this.auid, this.uid, data)
                  .pipe(first())
                  .subscribe(
                    data => {
                      if (data.isSuccess) {
                        var userId = localStorage.getItem("userId");
                        var automationID = localStorage.getItem("automationID");
                        if (userId && automationID) {
                          this.connectionservice.getActiveAtomationIds(Number(userId), Number(automationID)).subscribe((res: any) => {
                            localStorage.removeItem("userId");
                            localStorage.removeItem("automationID");
                          });
                        }
                        this.alertService.success(data.message, { keepAfterRouteChange: true });
                        this.automationservice.activateAutomation(this.auid, this.user, (result) => {
                          this.spinner.hide();
                          this.isProgress = false;
                          if (result.status == true) {
                            this.status = true;
                          } else {
                            // this.status=false;
                            // this.errorMsg=result.msg;
                            // this.alertService.error(result.msg, { keepAfterRouteChange: true });
                            this.errorHandler(result.msg);
                          }

                        });
                      }
                    },
                    error => {
                      this.errorHandler("");
                    })
              } else {
                // this.alertService.success(data.error, { keepAfterRouteChange: true });
                this.errorHandler(data.error);
              }
            },
            error => {
              error = "Slack Server Error";
              //this.alertService.error(error);
              this.errorHandler(error);
            })
      },
        error => {
          if (error == "Bad Request")
            error = "Open Authentication Detail Is Not Valid";
          // this.alertService.error(error);
          this.errorHandler(error);

        });

  }

  errorHandler(errorMsg: string) {
    this.spinner.hide();
    this.status = false;
    this.errorMsg = errorMsg;
  }

}
